$shm_hitalama_vk_group_search $shm_hitalama_components_embed
	token_str \
	dto null $shm_hitalama_vk_group_dto
	buttons /$mol_view
